import { createStore, ObservableMap } from "@stencil/store";
import { h } from "@stencil/core";
import { authClientName, getEnvConfig } from "../../api/config";
import { AuthClientInstance, getAuthClient } from "@trumpf/ux.utils";

const authClientServiceCalls: AuthClientInstance = getAuthClient(authClientName);
export interface AuthStoreState {
    isAuthenticating: boolean;
    authError: string | null;
}

export type AuthStore = ObservableMap<AuthStoreState>;

export const createAuthStore = () => {
    const store = createStore<AuthStoreState>({
        isAuthenticating: false,
        authError: null
    });

    return store;
};

export const SilentAuth = ({ disabled, config, authStore }) => {
    if (disabled || config.useMockData) return;

    const onAuthError = (e: CustomEvent): void => {
        authStore.state.authError = e.detail.error;
        if (authStore.state.authError !== null) {
            authStore.state.isAuthenticating = false;
        }
    };

    return (
        <ux-u-silent-auth
            client-name={authClientName}
            client-id={config.authClientId}
            issuer={config.authIssuer}
            scope={config?.authScope}
            onUxAuth={(e: CustomEvent) => onAuthError(e)}
        ></ux-u-silent-auth>
    );
};

/**
 * utility to execute a function as soon as the user is authenticated
 * @param fn callback to be executed as soon as the user is authenticated
 * @returns a function to unsubscribe
 */
export function whenAuthenticated(callback: () => void): () => void {
    const { useMockData } = getEnvConfig();
    if (authClientServiceCalls.getAccessToken() !== null || useMockData) {
        callback();
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return () => {};
    }
    return authClientServiceCalls.subscribe(callback);
}
